import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CompanyList } from '../util-cmps/database';
import { useDispatch, useSelector } from 'react-redux'
import { RootState, StoreDispatch } from '../../store/configure-store';
import { update } from '../../store/company';
import {utilService} from '../../services/util-service'


interface CompaniesDropDownProps {
    companies: CompanyList[]
}

export const CompaniesDropDown: React.FC<CompaniesDropDownProps> = ({ companies }) => {
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [filterText, setFilterText] = useState<string>('');
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch<StoreDispatch>()
    const company: any = useSelector((stateModule: RootState) => stateModule.companyName)!
    const dropdownRef = useRef<HTMLDivElement>(null)

    // Sync URL param ↔ Redux on mount and when company changes
    useEffect(() => {
        const urlCompany = searchParams.get('company')
        if (urlCompany && urlCompany !== company.value) {
            dispatch(update(urlCompany.toLowerCase()))
        } else if (company.value && !urlCompany) {
            setSearchParams(prev => {
                const next = new URLSearchParams(prev)
                next.set('company', company.value)
                return next
            }, { replace: true })
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Close on outside click
    useEffect(() => {
        if (!showDropdown) return
        const handleClickOutside = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setShowDropdown(false)
                setFilterText('')
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [showDropdown])

    const handleButtonClick = () => {
        if (showDropdown) setFilterText('')
        setShowDropdown(!showDropdown);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilterText(event.target.value.toLowerCase());
    };

    const handleOnSelect = (event:any) => {
        const selected = event.target.innerText.toLowerCase()
        dispatch(update(selected))
        setSearchParams(prev => {
            const next = new URLSearchParams(prev)
            next.set('company', selected)
            return next
        }, { replace: true })
        setShowDropdown(false)
        setFilterText('')
    }

    return (
        <div className="company-dropdown" ref={dropdownRef}>
            <button onClick={handleButtonClick} className="company-dropdown__btn">
                <span className="company-dropdown__icon">🏢</span>
                <span className={`company-dropdown__value ${!company.value ? 'company-dropdown__value--placeholder' : ''}`}>
                    {company.value ? utilService.capitalizeFirstLetter(company.value) : 'Select company...'}
                </span>
                <svg className="company-dropdown__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>
            <div className={`company-dropdown__menu ${showDropdown ? 'company-dropdown__menu--open' : ''}`}>
                <input type="text" placeholder="Search.." className="company-dropdown__search" value={filterText} onChange={handleInputChange} />
                <div className="company-dropdown__list">
                    {companies.map((_company) => {
                        return (<div key={_company.id}
                            className='company-dropdown__item'
                            onClick={(event)=>handleOnSelect(event)}
                            style={{ display: filterText === '' || _company.name.toLowerCase().includes(filterText) ? 'block' : 'none' }}>{utilService.capitalizeFirstLetter(_company.name)}</div>)
                    })}
                </div>
            </div>
        </div>
    );
};
